import type {ExperienceResourceOriginEnum} from '@api';
import {
    type ExperienceRequest,
    type ExperienceResource,
    type GetPreviewFromResumeRequest,
    type ResumePreviewResource,
    type UpdateBatchExperiencesRequest,
} from '@api';
import {type ResumeImportExperience, ResumeImportExperienceSource} from '../types/ResumeImportExperience';

export const resumeImportApiMapper = {
    toGetPreviewFromResumeRequest: (resume: File): GetPreviewFromResumeRequest => {
        return {
            resume,
        };
    },
    toUpdateExperiencesRequest: (experience: ResumeImportExperience): ExperienceRequest => ({
        id: experience.id,
        description: experience.description || '',
        title: experience.title || '',
        company: experience.company || '',
        companyId: experience.companyId,
        area: experience.area,
        startDate: experience.startDate || new Date(),
        endDate: experience.endDate,
        currentJob: experience.currentJob || false,
        location: experience.location,
        tags: experience.tags ?? [],
        skills: experience.skills ?? [],
        // recos: experience.recommendations || [],
        asFreelance: experience.asFreelancer || false,
        // logo: LogoResource,
        // TODO do not keep it like this: need to use a param
        requestOrigin: 'EDITION',
    }),
    toUpdateBatchExperiencesRequest: (resumeImportExperiences: ResumeImportExperience[]): UpdateBatchExperiencesRequest => ({
        updateExperiencesRequest: {
            experiences: resumeImportExperiences.map((resumeImportExperience) =>
                resumeImportApiMapper.toUpdateExperiencesRequest(resumeImportExperience),
            ),
        },
    }),
};

export const resumeImportDomainMapper = {
    toResumeImportDuplicateList: (resumePreview: ResumePreviewResource): string[][] => {
        return resumePreview.duplicatedExperienceIds || [];
    },
    toResumeImportExperience: (experience: ExperienceResource): ResumeImportExperience => {
        return {
            id: experience.id,
            title: experience.title,
            description: experience.description,
            company: experience.company,
            companyId: experience.companyId,
            area: experience.area,
            location: experience.location,
            startDate: experience.startDate,
            endDate: experience.endDate,
            currentJob: experience.currentJob,
            asFreelancer: experience.asFreelance,
            source: resumeImportDomainMapper.toResumeImportExperienceSource(experience.origin),
            tags: experience.tags ?? [],
            skills: experience.skills ?? [],
            recommendationCount: experience.recommendationCount || 0,
        };
    },
    toResumeImportExperiences: (resumePreview: ResumePreviewResource): ResumeImportExperience[] => {
        return resumePreview.experiences?.map((experience) => resumeImportDomainMapper.toResumeImportExperience(experience)) || [];
    },
    toResumeImportExperienceSource(origin?: ExperienceResourceOriginEnum): ResumeImportExperienceSource {
        switch (origin) {
            case 'PROFILE':
                return ResumeImportExperienceSource.MALT;
            case 'RESUME':
            default:
                return ResumeImportExperienceSource.RESUME;
        }
    },
};
